import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "control is-expanded" }
const _hoisted_3 = ["checked"]
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "control is-expanded" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { class: "control is-expanded" }
const _hoisted_10 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductSelect = _resolveComponent("ProductSelect")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass({'product-line': true, 'has-background-info': _ctx.values['transaction_type'] === 'BUY', 'has-background-danger': _ctx.values['transaction_type'] === 'SELL'})
  }, [
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _createElementVNode("input", {
            type: "radio",
            name: "is_key_contract",
            checked: _ctx.values['is_key_contract'],
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateRow && _ctx.updateRow(...args)))
          }, null, 40, _hoisted_3)
        ])
      ])
    ]),
    _createElementVNode("td", null, [
      _createVNode(_component_ProductSelect, {
        products: _ctx.products,
        errors: _ctx.apiErrors,
        onUpdate: _ctx.updateRowProduct,
        value: _ctx.values['product']
      }, null, 8, ["products", "errors", "onUpdate", "value"])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("input", {
            class: "input",
            type: "number",
            name: "price_ratio",
            value: _ctx.values['price_ratio'],
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateRow && _ctx.updateRow(...args))),
            onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.initValue && _ctx.initValue(...args)))
          }, null, 40, _hoisted_6)
        ]),
        (_ctx.apiErrors)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, [
          _createElementVNode("input", {
            class: "input",
            type: "number",
            name: "trade_ratio",
            value: _ctx.values['trade_ratio'],
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateRow && _ctx.updateRow(...args))),
            onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.initValue && _ctx.initValue(...args)))
          }, null, 40, _hoisted_10)
        ])
      ])
    ]),
    _createElementVNode("td", null, [
      (_ctx.isRemovable)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "button",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.removeRow && _ctx.removeRow(...args)))
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
          ]))]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}